import type {
  Documentation_ChangeRequestFilter,
  Documentation_RelatedPagesFilter,
  Documentation_SinglePageFilter,
} from '@tyro/api';

export const documentationKeys = {
  all: ['documentation'] as const,
  spaces: () => [...documentationKeys.all, 'spaces'] as const,
  space: (slug: string) => [...documentationKeys.all, 'space', slug] as const,
  pages: (spaceId: number) =>
    [...documentationKeys.all, 'pages', spaceId] as const,
  adminPages: (spaceId: number) =>
    [...documentationKeys.all, 'adminPages', spaceId] as const,
  allAdminPages: () => [...documentationKeys.all, 'allAdminPages'] as const,
  page: (filter: Documentation_SinglePageFilter) =>
    [...documentationKeys.all, 'page', filter] as const,
  pageDetail: (filter: Documentation_SinglePageFilter) =>
    [...documentationKeys.all, 'pageDetail', filter] as const,
  pageMetadata: (pageId: number) =>
    [...documentationKeys.all, 'pageMetadata', pageId] as const,
  search: (query: string) =>
    [...documentationKeys.all, 'search', query] as const,
  relatedPages: (filter: Documentation_RelatedPagesFilter) =>
    [...documentationKeys.all, 'relatedPages', filter] as const,
  pageVersions: (pageId: number) =>
    [...documentationKeys.all, 'pageVersions', pageId] as const,
  pageVersionContent: (versionId: number) =>
    [...documentationKeys.all, 'pageVersionContent', versionId] as const,
  changeRequests: (filter?: Documentation_ChangeRequestFilter) =>
    [...documentationKeys.all, 'changeRequests', filter] as const,
  releaseTags: () => [...documentationKeys.all, 'releaseTags'] as const,
  permissions: () => [...documentationKeys.all, 'permissions'] as const,
  changeRequest: (id: number) =>
    [...documentationKeys.all, 'changeRequest', id] as const,
  changeRequestDiff: (crId: number) =>
    [...documentationKeys.all, 'changeRequestDiff', crId] as const,
  conflictingChangeRequests: (crId: number) =>
    [...documentationKeys.all, 'conflictingChangeRequests', crId] as const,
};
